import React from 'react'
import { withCounter } from '../../hocs'

const HoverCounter = ({ count, incrementCount }) => (
  <h3 onMouseEnter={incrementCount}>Hovered over {count} times</h3>
)

export default withCounter(HoverCounter)
